import React, { useState, useCallback } from 'react';
import Input from '~/components/Form/Input';
import { Form } from '@unform/web';
import Select from '~/components/Form/SelectInput';

import { toast } from 'react-hot-toast';
import {
  Actions,
  ActionsInside,
  DeleteAndEditActions,
  InputsTable,
} from './styles';

import formatCompleteDate from '~/services/formatCompleteDate';
import formatDate from '~/services/formatDate';

import api from '~/services/api';

import {
  Modal,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
  Spinner,
} from 'reactstrap';
import { FaEye } from 'react-icons/fa';

export default function StockTransferManifestRow({ stock, getNfes }) {
  const [info, setInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hasNotExistInput, setHasNotExistInput] = useState(false);

  const [modalStock, setModalStock] = useState(false);
  function toggleStock() {
    setModalStock(!modalStock);
    setHasNotExistInput(false);
  }

  const openModal = useCallback(
    async (data) => {
      setLoading(true);
      try {
        const response = await api.get(
          `/restaurants/stock-transfer/${stock.id}`
        );
        setInfo(response.data);
        response.data.forEach((input) => {
          if (!input.exists) {
            setHasNotExistInput(true);
          }
        });
        setModalStock(true);
      } catch (err) {
        console.log('Error open modal:', err);
        toast.error('Falha ao carregar dados de transferencia de estoque');
      }
      setLoading(false);
    },
    [stock]
  );

  const updateStockTransfer = useCallback(async () => {
    setLoading(true);
    try {
      await api.put(`/restaurants/stock-transfer/accept/${stock.id}`, {
        info,
      });
      getNfes();
      setModalStock(false);
      toast.success('Estoque aceito com sucesso.');
    } catch (err) {
      console.log('Error update stock transfer:', err);
      toast.error('Falha ao carregar dados de transferencia de estoque');
    }
    setLoading(false);
  }, [stock, info]);

  const refuseStockTransfer = useCallback(async () => {
    setLoading(true);
    try {
      await api.put(`/restaurants/stock-transfer/refuse/${stock.id}`, {
        info,
      });
      getNfes();
      setModalStock(false);
      toast.success('Estoque recusado com sucesso.');
    } catch (err) {
      console.log('Error refuse stock transfer:', err);
      toast.error('Falha ao carregar dados de transferencia de estoque');
    }
    setLoading(false);
  }, [stock, info]);

  const itemsToCreate = info?.filter((inf) => !inf.exists) || [];
  const itemsToUpdate = info?.filter((inf) => inf.exists) || [];

  const inputsToCreate = itemsToCreate.filter((inf) => inf.input_origin);
  const inputsToUpdate = itemsToUpdate.filter((inf) => inf.input_origin);

  const intermediariesToCreate = itemsToCreate.filter(
    (inf) => inf.inter_origin
  );
  const intermediariesToUpdate = itemsToUpdate.filter(
    (inf) => inf.inter_origin
  );

  return (
    <>
      <tr>
        <td>{stock?.nome_emitente}</td>
        <td>{formatCompleteDate(stock?.data_emissao)}</td>
        <td>{stock?.chave_nfe}</td>
        <td>{stock?.numero}</td>
        <td>
          R$
          {parseFloat(stock?.valor_total || 0).toLocaleString('pt-br', {
            minimumFractionDigits: 2,
          })}
        </td>
        <td>
          {' '}
          <Actions>
            <ActionsInside>
              <DeleteAndEditActions>
                {!loading ? (
                  <FaEye
                    color="#01AFFF"
                    onClick={() => openModal()}
                    size={20}
                    style={{ cursor: 'pointer' }}
                  />
                ) : (
                  <Spinner size="sm" style={{ color: '#01AFFF' }} />
                )}
              </DeleteAndEditActions>
            </ActionsInside>
          </Actions>
        </td>
      </tr>

      <Modal isOpen={modalStock} toggle={toggleStock} size="lg">
        <ModalBody>
          <Form initialData={info}>
            <h5>Detalhes da Transferência</h5>
            <Row>
              <Col md="6">
                <Input
                  label="Para"
                  name="restaurant_dest"
                  value={stock?.nome_emitente}
                  disabled
                />
              </Col>
              <Col md="6">
                <Input
                  label="Status"
                  name="value"
                  value={stock.status === 'created' && 'Pendente'}
                  disabled
                />
              </Col>
            </Row>

            <Row>
              <Col md="4">
                <Input
                  label="Criada"
                  name="createdAt"
                  value={formatCompleteDate(stock?.createdAt)}
                  disabled
                />
              </Col>
              <Col md="4">
                <Input
                  label="Valor"
                  name="value"
                  value={`R$${stock?.value?.toLocaleString('pt-br', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                  })}`}
                  disabled
                />
              </Col>
              <Col md="4">
                <Input
                  label="Vencimento"
                  name="due_date"
                  value={formatDate(stock?.due_date)}
                  disabled
                />
              </Col>
            </Row>

            <Row style={{ marginTop: 7, marginBottom: 7 }}>
              <Col md="12">
                <strong>Observações: </strong>
                {`  ${stock?.observation}`}
              </Col>
            </Row>

            <Row
              style={{ marginTop: 17, marginBottom: 10, textAlign: 'center' }}
            >
              <Col md="12">
                <strong>Itens que existem em seu estoque </strong>
              </Col>
            </Row>

            <Row>
              <Col md="12">
                <InputsTable borderless>
                  <thead>
                    <tr>
                      <th>Insumo</th>
                      <th>Quantidade</th>
                      <th>Custo unitário</th>
                      <th>Custo total</th>
                      <th>Novo Custo Unitário</th>
                    </tr>
                  </thead>

                  <tbody>
                    {inputsToUpdate.length > 0 ? (
                      inputsToUpdate.map((input) => (
                        <tr>
                          <td>{input.input_origin.name}</td>

                          <td>
                            {parseFloat(input.quantidade).toFixed(2)}{' '}
                            {input.input_origin.unidade}
                          </td>

                          <td>
                            R$
                            {parseFloat(input.unitary_price)?.toLocaleString(
                              'pt-br',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>

                          <td>
                            R$
                            {parseFloat(input.total_price)?.toLocaleString(
                              'pt-br',
                              {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              }
                            )}
                          </td>

                          <td>
                            <div style={{ marginBottom: 30 }}>
                              <Select
                                name="select_unitary_price"
                                options={[
                                  {
                                    value: 'new',
                                    label: `Novo (R$${parseFloat(
                                      input.unitary_price
                                    )?.toLocaleString('pt-br', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })})`,
                                    price: input.unitary_price,
                                  },
                                  {
                                    value: 'media',
                                    label: `Média (R$${(
                                      (parseFloat(input.unitary_price) *
                                        parseFloat(input.quantidade) +
                                        parseFloat(
                                          input.input_dest.unitary_price
                                        ) *
                                          parseFloat(
                                            input.input_dest.quantidade
                                          )) /
                                      (parseFloat(input.quantidade) +
                                        parseFloat(input.input_dest.quantidade))
                                    )?.toLocaleString('pt-br', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })})`,
                                    price: (
                                      (parseFloat(input.unitary_price) *
                                        parseFloat(input.quantidade) +
                                        parseFloat(
                                          input.input_dest.unitary_price
                                        ) *
                                          parseFloat(
                                            input.input_dest.quantidade
                                          )) /
                                      (parseFloat(input.quantidade) +
                                        parseFloat(input.input_dest.quantidade))
                                    )?.toLocaleString('pt-br', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }),
                                  },
                                ]}
                                defaultValue={{
                                  value: 'new',
                                  label: `Novo (R$${parseFloat(
                                    input.unitary_price
                                  )?.toLocaleString('pt-br', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  })})`,
                                }}
                                onChange={(e) => {
                                  input.new_unitary_price = e.price;
                                  console.log('aaaaa', input);
                                }}
                              />
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td> - </td>
                        <td> - </td>
                        <td> - </td>
                        <td> - </td>
                      </tr>
                    )}
                  </tbody>
                  <thead style={{ marginTop: 15 }}>
                    <tr>
                      <th>Produto Intermediário</th>
                      <th></th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>

                  <tbody>
                    {intermediariesToUpdate.length > 0 ? (
                      intermediariesToUpdate.map((input) => {
                        // Isso aqui é pra parar de dar tela branca em um caso que a matriz quis transferir um intermadiário de la para um insumo da loja filha
                        const destination =
                          input.inter_dest || input.input_dest;

                        return (
                          <tr>
                            <td>{input.inter_origin.name}</td>
                            <td>
                              {parseFloat(input.quantidade).toFixed(2)}{' '}
                              {input.inter_origin.unidade}
                            </td>
                            <td>
                              R$
                              {parseFloat(input.unitary_price)?.toLocaleString(
                                'pt-br',
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </td>
                            <td>
                              R$
                              {parseFloat(input.total_price)?.toLocaleString(
                                'pt-br',
                                {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                }
                              )}
                            </td>
                            <td>
                              <div style={{ marginBottom: 30 }}>
                                <Select
                                  name="select_unitary_price_inter"
                                  options={[
                                    {
                                      value: 'new',
                                      label: `Novo (R$${parseFloat(
                                        input.unitary_price
                                      )?.toLocaleString('pt-br', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })})`,
                                      price: input.unitary_price,
                                    },
                                    {
                                      value: 'media',
                                      label: `Média (R$${(
                                        (parseFloat(input.unitary_price) *
                                          parseFloat(input.quantidade) +
                                          parseFloat(
                                            destination.unitary_price
                                          ) *
                                            parseFloat(
                                              destination.quantidade
                                            )) /
                                        (parseFloat(input.quantidade) +
                                          parseFloat(destination.quantidade))
                                      )?.toLocaleString('pt-br', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })})`,
                                      price: (
                                        (parseFloat(input.unitary_price) *
                                          parseFloat(input.quantidade) +
                                          parseFloat(
                                            destination.unitary_price
                                          ) *
                                            parseFloat(
                                              destination.quantidade
                                            )) /
                                        (parseFloat(input.quantidade) +
                                          parseFloat(destination.quantidade))
                                      )?.toLocaleString('pt-br', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      }),
                                    },
                                  ]}
                                  defaultValue={{
                                    value: 'new',
                                    label: `Novo (R$${parseFloat(
                                      input.unitary_price
                                    )?.toLocaleString('pt-br', {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })})`,
                                  }}
                                  onChange={(e) => {
                                    input.new_unitary_price = e.price;
                                    console.log('aaaaa', input);
                                  }}
                                />
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td> - </td>
                        <td> - </td>
                        <td> - </td>
                        <td> - </td>
                      </tr>
                    )}
                  </tbody>
                </InputsTable>
              </Col>
            </Row>

            {hasNotExistInput && (
              <div>
                <Row
                  style={{
                    marginTop: 13,
                    marginBottom: 13,
                    textAlign: 'center',
                  }}
                >
                  <Col md="12">
                    <strong>Itens que serão criados no seu estoque </strong>
                  </Col>
                </Row>

                <Row>
                  <Col md="12">
                    <InputsTable borderless>
                      <thead>
                        <tr>
                          <th>Insumo</th>
                          <th>Quantidade</th>
                          <th>Custo unitário</th>
                          <th>Custo total</th>
                        </tr>
                      </thead>

                      <tbody>
                        {inputsToCreate.length > 0 &&
                          inputsToCreate.map((input) => (
                            <tr>
                              <td>{input.input_origin.name}</td>

                              <td>
                                {parseFloat(input.quantidade).toFixed(2)}{' '}
                                {input.input_origin.unidade}
                              </td>

                              <td>
                                R$
                                {parseFloat(
                                  input.unitary_price
                                )?.toLocaleString('pt-br', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>

                              <td>
                                R$
                                {parseFloat(input.total_price)?.toLocaleString(
                                  'pt-br',
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                            </tr>
                          ))}
                        {intermediariesToCreate.length > 0 &&
                          intermediariesToCreate.map((input) => (
                            <tr>
                              <td>{input.inter_origin.name}</td>

                              <td>
                                {parseFloat(input.quantidade).toFixed(2)}{' '}
                                {input.inter_origin.unidade}
                              </td>

                              <td>
                                R$
                                {parseFloat(
                                  input.unitary_price
                                )?.toLocaleString('pt-br', {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>

                              <td>
                                R$
                                {parseFloat(input.total_price)?.toLocaleString(
                                  'pt-br',
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </InputsTable>
                  </Col>
                </Row>
              </div>
            )}
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            onClick={() => refuseStockTransfer()}
            disabled={loading}
          >
            Recusar
          </Button>
          <Button
            color="success"
            onClick={() => updateStockTransfer()}
            disabled={loading}
          >
            Aceitar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}
